<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div
      id="kt_app_content_container"
      class="app-container container-fluid org-page-container"
    >
      <div>
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div class="d-flex flex-column">
            <h3 class="card-label fw-bold fs-3 mb-1">
              {{ orgConfig.pageTitleKey | translate }}
            </h3>
          </div>

          <div class="d-flex align-items-center gap-3">
            <button
              class="btn btn-icon btn-active-light-primary cursor-pointer"
              (mouseenter)="showTooltip($event, 'filter')"
              (mouseleave)="hideTooltip()"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOrg"
              aria-expanded="false"
              aria-controls="collapseOrg"
            >
              <i class="fa-solid fa-filter"></i>
            </button>

            <!-- Custom tooltip element -->
            <div
              class="risk-tooltip"
              *ngIf="activeTooltip"
              [style.left.px]="activeTooltip.x"
              [style.top.px]="activeTooltip.y"
            >
              {{ activeTooltip.text }}
            </div>

            <button
              type="button"
              (click)="openCreateModal()"
              class="btn btn-sm fw-bold btn-primary"
            >
              {{ "organization.createOrganization" | translate }}
            </button>
          </div>
        </div>

        <div>
          <div class="collapse mb-8" id="collapseOrg">
            <form (submit)="filterList($event)">
              <div class="row align-items-end">
                <div class="col-xl-3 col-lg-4 mt-xl-0 mt-4 col-sm-6">
                  <label class="form-label fs-14">{{
                    "name" | translate
                  }}</label>
                  <input
                    [(ngModel)]="filterForm.name"
                    type="text"
                    class="form-control fs-14"
                    name="orgName"
                    [placeholder]="'organization.filterByName' | translate"
                  />
                </div>

                <div class="col-xl-3 col-lg-4 mt-xl-0 mt-4 col-sm-6">
                  <label class="form-label fs-14">{{
                    "customerCode" | translate
                  }}</label>
                  <input
                    [(ngModel)]="filterForm.customerCode"
                    type="text"
                    class="form-control fs-14"
                    name="organization.customerCode"
                    [placeholder]="
                      'organization.filterByCustomerCode' | translate
                    "
                  />
                </div>

                <div class="col-xl-3 col-lg-4 mt-xl-0 mt-4 col-sm-6">
                  <label class="form-label fs-14">{{
                    "email" | translate
                  }}</label>
                  <input
                    [(ngModel)]="filterForm.email"
                    type="email"
                    class="form-control fs-14"
                    name="email"
                    [placeholder]="'filterByEmail' | translate"
                  />
                </div>

                <div class="col-xl-3 col-lg-4 mt-xl-0 mt-4 col-sm-6">
                  <div
                    class="d-flex justify-content-xl-end justify-content-start gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-secondary cursor-pointer fs-14"
                      (click)="clearFilters()"
                    >
                      {{ "clear" | translate }}
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary cursor-pointer fs-14"
                    >
                      {{ "filter" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div>
          <div *ngIf="isLoading" class="d-flex justify-content-center pb-4">
            <div class="spinner-border text-danger" role="status">
              <span class="visually-hidden"
                >{{ "loading" | translate }}...</span
              >
            </div>
          </div>

          <div
            *ngIf="!isLoading && orgCards.length === 0"
            class="py-5 text-center fs-5"
          >
            {{ "organization.noOrganizationsFound" | translate }}
          </div>

          <div class="grid-header" *ngIf="orgConfig.columns.length > 0">
            <ng-container *ngFor="let col of orgConfig.columns">
              <div
                [ngClass]="getColClass(col)"
                (click)="col.key === 'name' ? onSort(col.key) : null"
                [class.cursor-pointer]="col.key === 'name'"
              >
                {{ col.labelKey | translate }}
                <ng-container *ngIf="sortBy === col.key && col.key === 'name'">
                  <i
                    class="fa-solid ms-1"
                    style="font-size: 0.65em !important; vertical-align: middle"
                    [ngClass]="{
                      'fa-chevron-down': sortDirection === 'desc',
                      'fa-chevron-up': sortDirection === 'asc',
                    }"
                  ></i>
                </ng-container>
              </div>
            </ng-container>
          </div>

          <ng-container *ngIf="!isLoading && organizations.length > 0">
            <app-dynamic-list
              *ngFor="let org of organizations"
              [item]="org"
              [columns]="orgConfig.columns"
              [actions]="orgConfig.actions"
              [disableScrollableItems]="true"
              (click)="onCardClick(org)"
            >
            </app-dynamic-list>
          </ng-container>
        </div>

        <ng-container *ngIf="!isLoading && orgCards.length > 0">
          <div class="d-flex flex-stack flex-wrap pt-10">
            <div class="d-flex align-items-center gap-6">
              <div class="flex align-items-center gap-2">
                <label class="me-2 fs-6 fw-semibold text-gray-700">
                  {{ "pageSize" | translate }}:
                </label>
                <app-page-size-selector
                  [sizes]="pageSizes"
                  [selectedSize]="pageSize"
                  (sizeChange)="changePageSize($event)"
                >
                </app-page-size-selector>
              </div>
              <div class="fs-6 fw-semibold text-gray-700">
                {{ "showing" | translate }} {{ orgCards.length }}
                {{ "of" | translate }} {{ totalItems }}
                {{ "organization.organizations" | translate }}
              </div>
            </div>

            <ul class="pagination">
              <li
                class="page-item previous cursor-pointer"
                [class.disabled]="currentPage === 1"
              >
                <a class="page-link" (click)="previousPage(currentPage)">
                  <i class="previous"></i>
                </a>
              </li>

              <li
                *ngFor="let page of [].constructor(totalPage); let i = index"
                class="page-item cursor-pointer"
                [class.active]="currentPage === i + 1"
              >
                <a class="page-link" (click)="changePage(i)">
                  {{ i + 1 }}
                </a>
              </li>

              <li
                class="page-item next cursor-pointer"
                [class.disabled]="currentPage === totalPage"
              >
                <a class="page-link" (click)="nextPage(currentPage + 1)">
                  <i class="next"></i>
                </a>
              </li>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Hidden button to trigger delete modal -->
<button
  #openDeleteModalBtn
  type="button"
  class="d-none"
  data-bs-toggle="modal"
  data-bs-target="#deleteOrganizationModal"
></button>

<!-- Delete Organization Modal -->
<div
  class="modal fade"
  id="deleteOrganizationModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2">
          {{ "organization.deleteOrganization" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4">
        {{ "organization.areYouSureDeleteOrg" | translate }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "cancel" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-danger cursor-pointer"
          data-bs-dismiss="modal"
          (click)="confirmDelete()"
        >
          {{ "delete" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
